export enum IDENTITY_PROVIDERS {
    /**
     * @value API token
     * @description This is the API token used for user synchronisation with Okta.
     */
    API_TOKEN = 'ADMIN.PROVIDER.API_TOKEN',
    /**
     * @value The API token is used for tracking API calls
     */
    API_TOKEN_HELPER = 'ADMIN.PROVIDER.API_TOKEN_HELPER',
    /**
     * @value Force login to Login Provider
     */
    AUTHENTICATE_EACH_LOGIN_ENABLED = 'ADMIN.PROVIDER.AUTHENTICATE_EACH_LOGIN_ENABLED',
    /**
     * @value Force the connection to the login provider portal for each user login via SAML to refresh the integrations tokens.
     */
    AUTHENTICATE_EACH_LOGIN_HELPER = 'ADMIN.PROVIDER.AUTHENTICATE_EACH_LOGIN_HELPER',
    /**
     * @value Force login for all users from this source, using their source credentials.
     */
    AUTO_SYNC_HELPER = 'ADMIN.PROVIDER.AUTO_SYNC_HELPER',
    /**
     * @value Automatic login
     */
    AUTO_SYNC_LABEL = 'ADMIN.PROVIDER.AUTO_SYNC_LABEL',
    /**
     * @value Background color
     */
    BACKGROUND_COLOR = 'ADMIN.RESELLER_CONSOLE_CUSTOMER.BACKGROUND_COLOR',
    /**
     * @value Beekeeper
     */
    BEEKEEPER = 'IDENTITY_PROVIDER.BEEKEEPER',
    /**
     * @value Client Credentials
     */
    CRED = 'ADMIN.PROVIDER.CRED',
    /**
     * @value Client ID
     */
    CRED_CLIENT_ID = 'ADMIN.PROVIDER.CRED_CLIENT_ID',
    /**
     * @value Public identifier for the client that is required for all OAuth flows
     */
    CRED_CLIENT_ID_HELPER = 'ADMIN.PROVIDER.CRED_CLIENT_ID_HELPER',
    /**
     * @value Client Secret
     */
    CRED_SECRET = 'ADMIN.PROVIDER.CRED_SECRET',
    /**
     * @value Secret used by the client to exchange an authorization code for a token. This must be kept confidential. Do not include it in apps which cannot keep it secret, such as those running on a client.
     */
    CRED_SECRET_HELPER = 'ADMIN.PROVIDER.CRED_SECRET_HELPER',
    /**
     * @value Login domain
     */
    CUSTOMER_LOGIN_DOMAIN = 'ADMIN_RESELLER_CONSOLE_CUSTOMER_LOGIN_DOMAIN',
    /**
     * @value Redirect users to the specified login domain
     */
    CUSTOMER_SSO_DOMAIN_HINT = 'ADMIN_RESELLER_CONSOLE_CUSTOMER_SSO_DOMAIN_HINT',
    /**
     * @value Sync the "hide this user" field
     */
    CUSTOMER_SYNC_HIDE_USER = 'ADMIN_RESELLER_CONSOLE_CUSTOMER_SYNC_HIDE_USER',
    /**
     * @value Synchronize the field "hide this user" from the identity provider directory
     */
    CUSTOMER_SYNC_HIDE_USER_HELP = 'ADMIN_RESELLER_CONSOLE_CUSTOMER_SYNC_HIDE_USER_HELP',
    /**
     * @value Are you sure you want to delete this provider?
     */
    DELETE_CONFIRM_CONTENT = 'ADMIN.PROVIDER.DELETE_CONFIRM_CONTENT',
    /**
     * @value Delete provider
     */
    DELETE_CONFIRM_TITLE = 'ADMIN.PROVIDER.DELETE_CONFIRM_TITLE',
    /**
     * @value An error occurred when deleting the provider.
     */
    DELETE_ERROR = 'ADMIN.PROVIDER.DELETE.ERROR',
    /**
     * @value The provider has been deleted successfully.
     */
    DELETE_SUCCESS = 'ADMIN.PROVIDER.DELETE.SUCCESS',
    /**
     * @value Existing LumApps users remain active when provisioning is disabled.
     */
    DISABLE_PROVISIONING_WARNING = 'ADMIN.PROVIDER.DISABLE_PROVISIONING_WARNING',
    /**
     * @value An error occurred while retrieving metadata file
     */
    DOWNLOAD_SP_ERROR = 'ADMIN.PROVIDER.DOWNLOAD_SP.ERROR',
    /**
     * @value Edit provider
     */
    EDIT_PROVIDER = 'ADMIN.PROVIDER.EDIT_PROVIDER',
    /**
     * @value You can edit your identity providers in the section
     */
    EDIT_PROVIDER_INFO_MESSAGE = 'ADMIN.PROVIDER.INFO_MESSAGE.EDIT_PROVIDER',
    /**
     * @value "Installed extensions"
     */
    EDIT_PROVIDER_LINK_TEXT = 'ADMIN.PROVIDER.INFO_MESSAGE.EDIT_PROVIDER_LINK_TEXT',
    /**
     * @value This section gives you access to identity providers
     */
    EMPTY_STATE_DESCRIPTION = 'PROVIDERS.EMPTY_STATE_DESCRIPTION',
    /**
     * @value There are no identity providers yet
     */
    EMPTY_STATE_TITLE = 'PROVIDERS.EMPTY_STATE_TITLE',
    /**
     * @value Each time the "Enable login" is activated, a manual user synchronization is required before users can log in. Please contact the Support team. More information about the user synchronization can be found in the %DOCUMENTATION%.
     */
    ENABLE_LOGIN_INFO = 'IDENTITY_PROVIDERS.ENABLE_LOGIN_INFO',
    /**
     * @value Enable magic link login
     */
    ENABLE_MAGIC_LINK_LOGIN = 'ADMIN.PROVIDER.ENABLE_MAGIC_LINK_LOGIN',
    /**
     * @value Enable password login
     */
    ENABLE_PASSWORD_LOGIN = 'ADMIN.PROVIDER.ENABLE_PASSWORD_LOGIN',
    /**
     * @value Exceptions
     */
    EXCEPTIONS = 'ADMIN.PROVIDER.EXCEPTIONS',
    /**
     * @value Condition
     */
    EXCEPTIONS_FIELD_CONDITION = 'ADMIN.PROVIDER.EXCEPTIONS_FIELD_CONDITION',
    /**
     * @value Field name
     */
    EXCEPTIONS_FIELD_NAME = 'ADMIN.PROVIDER.EXCEPTIONS_FIELD_NAME',
    /**
     * @value Field type
     */
    EXCEPTIONS_FIELD_TYPE = 'ADMIN.PROVIDER.EXCEPTIONS_FIELD_TYPE',
    /**
     * @value Field value
     */
    EXCEPTIONS_FIELD_VALUE = 'ADMIN.PROVIDER.EXCEPTIONS_FIELD_VALUE',
    /**
     * @value Prevent the synchronization of selected user accounts by selecting a user profile field and a value. Users with this field set to this value are excluded from the daily synchronization.
     */
    EXCEPTIONS_HELPER = 'ADMIN.PROVIDER.EXCEPTIONS_HELPER',
    /**
     * @value Download file and import it in your identity provider
     */
    EXPORT_METADATA_HELPER = 'ADMIN.RESELLER_CONSOLE_CUSTOMER.EXPORT_METADATA_HELPER',
    /**
     * @value Extranet feature
     */
    EXTRANET_FEATURE = 'ADMIN.PROVIDER.EXTRANET_OPTION_TITLE',
    /**
     * @value Users created with this provider will be added as members of the selected groups.
     */
    EXTRANET_GROUP_PICKER_HELPER = 'ADMIN.PROVIDER.GROUP_PICKER_HELPER',
    /**
     * @value Automatic group membership
     */
    EXTRANET_GROUP_PICKER_LABEL = 'ADMIN.PROVIDER.GROUP_PICKER_LABEL',
    /**
     * @value Select sites to show the login button on
     */
    EXTRANET_INSTANCE_PICKER_LABEL = 'ADMIN.PROVIDER.INSTANCE_PICKER_LABEL',
    /**
     * @value Show login button in selected sites only
     */
    EXTRANET_VISIBILITY_INSTANCE_HELPER = 'ADMIN.PROVIDER.VISIBILITY_INSTANCE_HELPER',
    /**
     * @value Show login button in all platform sites
     */
    EXTRANET_VISIBILITY_PLATFORM_HELPER = 'ADMIN.PROVIDER.VISIBILITY_PLATFORM_HELPER',
    /**
     * @value Enable the federation on the "Employee ID" field
     */
    FEDERATE_ON_EMPLOYEEID = 'ADMIN.PROVIDER.FEDERATE_ON_EMPLOYEEID',
    /**
     * @value During the synchronization, the users will be federated using the "Employee ID" field
     */
    FEDERATE_ON_EMPLOYEEID_HELPER = 'ADMIN.PROVIDER.FEDERATE_ON_EMPLOYEEID_HELPER',
    /**
     * @deprecated use ReferToDocumentation component instead
     * @value For more information, refer to the
     * @description a space should be present at the end of this sentence.
     */
    FOR_MORE_INFO_REFER_TO = 'ADMIN.PROVIDER.FOR_MORE_INFO_REFER_TO',
    /**
     * @value Enable integrations for existing users only
     */
    HAS_INTEGRATION_ONLY = 'ADMIN.PROVIDER.HAS_INTEGRATION_ONLY',
    /**
     * @value Users are never created from this provider but the existing users can use its integrations
     */
    HAS_INTEGRATION_ONLY_HELPER = 'ADMIN.PROVIDER.HAS_INTEGRATION_ONLY_HELPER',
    /**
     * @value Identity providers
     */
    IDP = 'ADMIN.NAV.PROVIDER.IDP',
    /**
     * @value Metadata file generated by your identity provider
     */
    IMPORT_METADATA_HELPER = 'ADMIN.RESELLER_CONSOLE_CUSTOMER.IMPORT_METADATA_HELPER',
    /**
     * @value Allow on-the-fly user creation
     */
    JIT_ENABLED = 'ADMIN.PROVIDER.JIT_ENABLED',
    /**
     * @value Allow JIT (Just-in-Time) provisioning for this SAML provider. Users will be created if they do not exist in the Intranet.
     */
    JIT_ENABLED_HELPER = 'ADMIN.PROVIDER.JIT_ENABLED_HELPER',
    /**
     * @value Login button
     */
    LOGIN_BUTTON = 'ADMIN.RESELLER_CONSOLE_CUSTOMER.LOGIN_BUTTON',
    /**
     * @value Choose the appearance of the button.
     */
    LOGIN_BUTTON_HELPER = 'ADMIN.RESELLER_CONSOLE_CUSTOMER.LOGIN_BUTTON_HELPER',
    /**
     * @value Please upload a square image less than 300 KB.
     */
    LOGIN_BUTTON_INFO = 'ADMIN.RESELLER_CONSOLE_CUSTOMER.LOGIN_BUTTON_INFO',
    /**
     * @value Enable login
     */
    LOGIN_ENABLED = 'ADMIN.PROVIDER.LOGIN_ENABLED',
    /**
     * @value Displays the login button for this provider on the login page
     */
    LOGIN_ENABLED_HELPER = 'ADMIN.PROVIDER.LOGIN_ENABLED_HELPER',
    /**
     * @value Fill login hint field
     */
    LOGIN_HINT_ENABLED = 'ADMIN.PROVIDER.LOGIN_HINT_ENABLED',
    /**
     * @value Allow LumApps to use the email address on login provider portal to pre-fill the connection form (Microsoft) or pre-select the right account (Google).
     */
    LOGIN_HINT_HELPER = 'ADMIN.PROVIDER.LOGIN_HINT_HELPER',
    /**
     * @value LumApps Provider
     * @description Name of the LumApps (email and password) identity provider: its row in the identity providers list, the header of its dialog and the title of its settings page.
     */
    LUMAPPS_PROVIDER = 'IDENTITY_PROVIDERS.LUMAPPS_PROVIDER',
    /**
     * @value LumApps Provider authentication
     * @description Title of the first section of the LumApps Provider settings page, holding the switch that turns sign-in with LumApps on or off.
     */
    LUMAPPS_PROVIDER_AUTHENTICATION = 'IDENTITY_PROVIDERS.LUMAPPS_PROVIDER_AUTHENTICATION',
    /**
     * @value Enable login with LumApps
     * @description Label of the master switch that turns every LumApps sign-in method (password, magic link) on or off for the organization.
     */
    LUMAPPS_PROVIDER_ENABLE_LOGIN = 'IDENTITY_PROVIDERS.LUMAPPS_PROVIDER_ENABLE_LOGIN',
    /**
     * @value Allow users to sign in with an account managed in LumApps, using the sign-in methods enabled on this page.
     * @description Helper text under the Enable login with LumApps master switch.
     */
    LUMAPPS_PROVIDER_ENABLE_LOGIN_HELPER = 'IDENTITY_PROVIDERS.LUMAPPS_PROVIDER_ENABLE_LOGIN_HELPER',
    /**
     * @value Force password change (days before expiry)
     * @description Label of the number field setting how many days before expiry users are forced to change their password.
     */
    LUMAPPS_PROVIDER_FORCE_CHANGE_BEFORE_EXPIRY = 'IDENTITY_PROVIDERS.LUMAPPS_PROVIDER_FORCE_CHANGE_BEFORE_EXPIRY',
    /**
     * @value Must be less than the reminder period.
     * @description Validation error when the forced change period is not shorter than the reminder period.
     */
    LUMAPPS_PROVIDER_FORCE_CHANGE_ERROR = 'IDENTITY_PROVIDERS.LUMAPPS_PROVIDER_FORCE_CHANGE_ERROR',
    /**
     * @value Enable forgotten password
     * @description Label of the switch that lets users request a password reset link from the sign-in page, in the Password login section of the LumApps Provider settings page.
     */
    LUMAPPS_PROVIDER_FORGOTTEN_PASSWORD = 'IDENTITY_PROVIDERS.LUMAPPS_PROVIDER_FORGOTTEN_PASSWORD',
    /**
     * @value Let users request a password reset link from the sign-in page.
     * @description Helper text under the Enable forgotten password switch of the Password login section.
     */
    LUMAPPS_PROVIDER_FORGOTTEN_PASSWORD_HELPER = 'IDENTITY_PROVIDERS.LUMAPPS_PROVIDER_FORGOTTEN_PASSWORD_HELPER',
    /**
     * @value Magic links
     * @description Title of the Magic links section of the LumApps Provider settings page.
     */
    LUMAPPS_PROVIDER_MAGIC_LINKS = 'IDENTITY_PROVIDERS.LUMAPPS_PROVIDER_MAGIC_LINKS',
    /**
     * @value Magic link expiration
     * @description Label of the select setting how long a sign-in link sent by email stays valid.
     */
    LUMAPPS_PROVIDER_MAGIC_LINK_EXPIRATION = 'IDENTITY_PROVIDERS.LUMAPPS_PROVIDER_MAGIC_LINK_EXPIRATION',
    /**
     * @value Also applies to the link sent for 2-step verification.
     * @description Helper text under the magic link expiration select.
     */
    LUMAPPS_PROVIDER_MAGIC_LINK_EXPIRATION_HELPER = 'IDENTITY_PROVIDERS.LUMAPPS_PROVIDER_MAGIC_LINK_EXPIRATION_HELPER',
    /**
     * @value Magic link login: off
     * @description Confirmation dialog list item: turning 2-step verification on turns magic link login off.
     */
    LUMAPPS_PROVIDER_MAGIC_LINK_LOGIN_EFFECT = 'IDENTITY_PROVIDERS.LUMAPPS_PROVIDER_MAGIC_LINK_LOGIN_EFFECT',
    /**
     * @value Allow users to sign in using a one-time link sent to their email, without entering a password.
     * @description Helper text under the Enable magic link login switch of the LumApps Provider settings page.
     */
    LUMAPPS_PROVIDER_MAGIC_LINK_LOGIN_HELPER = 'IDENTITY_PROVIDERS.LUMAPPS_PROVIDER_MAGIC_LINK_LOGIN_HELPER',
    /**
     * @value Minimum password length (characters)
     * @description Label of the number field setting the minimum number of characters of a user password.
     */
    LUMAPPS_PROVIDER_MIN_PASSWORD_LENGTH = 'IDENTITY_PROVIDERS.LUMAPPS_PROVIDER_MIN_PASSWORD_LENGTH',
    /**
     * @value Applies to new and changed passwords.
     * @description Helper text under the minimum password length field: existing passwords are not affected.
     */
    LUMAPPS_PROVIDER_MIN_PASSWORD_LENGTH_HELPER = 'IDENTITY_PROVIDERS.LUMAPPS_PROVIDER_MIN_PASSWORD_LENGTH_HELPER',
    /**
     * @value The LumApps Provider of this organization could not be found.
     * @description Error state of the LumApps Provider settings page when the organization has no LumApps (email) identity provider.
     */
    LUMAPPS_PROVIDER_NOT_FOUND = 'IDENTITY_PROVIDERS.LUMAPPS_PROVIDER_NOT_FOUND',
    /**
     * @value No sign-in method is enabled. Users can't sign in with LumApps.
     * @description Warning under the master switch when login with LumApps is on but neither password login nor magic link login is on.
     */
    LUMAPPS_PROVIDER_NO_SIGN_IN_METHOD = 'IDENTITY_PROVIDERS.LUMAPPS_PROVIDER_NO_SIGN_IN_METHOD',
    /**
     * @value Enter a number from %MIN% to %MAX%.
     * @description Validation error of a number field of the LumApps Provider settings page. MIN and MAX are the allowed bounds.
     */
    LUMAPPS_PROVIDER_NUMBER_RANGE_ERROR = 'IDENTITY_PROVIDERS.LUMAPPS_PROVIDER_NUMBER_RANGE_ERROR',
    /**
     * @value Password complexity
     * @description Legend of the group of checkboxes listing the character types a password must contain.
     */
    LUMAPPS_PROVIDER_PASSWORD_COMPLEXITY = 'IDENTITY_PROVIDERS.LUMAPPS_PROVIDER_PASSWORD_COMPLEXITY',
    /**
     * @value Password expires after (days)
     * @description Label of the number field setting after how many days a password expires.
     */
    LUMAPPS_PROVIDER_PASSWORD_EXPIRES_AFTER = 'IDENTITY_PROVIDERS.LUMAPPS_PROVIDER_PASSWORD_EXPIRES_AFTER',
    /**
     * @value Password login
     * @description Title of the Password login section of the LumApps Provider settings page.
     */
    LUMAPPS_PROVIDER_PASSWORD_LOGIN = 'IDENTITY_PROVIDERS.LUMAPPS_PROVIDER_PASSWORD_LOGIN',
    /**
     * @value Allow users to sign in with passwords and manage the security rules applied to password authentication.
     * @description Description of the Password login section of the LumApps Provider settings page.
     */
    LUMAPPS_PROVIDER_PASSWORD_LOGIN_DESCRIPTION = 'IDENTITY_PROVIDERS.LUMAPPS_PROVIDER_PASSWORD_LOGIN_DESCRIPTION',
    /**
     * @value Password login: on, visible on Web & Mobile application
     * @description Confirmation dialog list item: turning 2-step verification on forces password login on, visible on web and mobile.
     */
    LUMAPPS_PROVIDER_PASSWORD_LOGIN_EFFECT = 'IDENTITY_PROVIDERS.LUMAPPS_PROVIDER_PASSWORD_LOGIN_EFFECT',
    /**
     * @value Allow users to sign in using an email and password managed within LumApps.
     * @description Helper text under the Enable password login switch of the LumApps Provider settings page.
     */
    LUMAPPS_PROVIDER_PASSWORD_LOGIN_HELPER = 'IDENTITY_PROVIDERS.LUMAPPS_PROVIDER_PASSWORD_LOGIN_HELPER',
    /**
     * @value Require periodic password change
     * @description Label of the switch forcing users to change their password at a fixed interval.
     */
    LUMAPPS_PROVIDER_PERIODIC_PASSWORD_CHANGE = 'IDENTITY_PROVIDERS.LUMAPPS_PROVIDER_PERIODIC_PASSWORD_CHANGE',
    /**
     * @value Users must change their password at the configured interval.
     * @description Helper text under the Require periodic password change switch.
     */
    LUMAPPS_PROVIDER_PERIODIC_PASSWORD_CHANGE_HELPER = 'IDENTITY_PROVIDERS.LUMAPPS_PROVIDER_PERIODIC_PASSWORD_CHANGE_HELPER',
    /**
     * @value Start reminding users (days before expiry)
     * @description Label of the number field setting how many days before expiry users start getting reminders.
     */
    LUMAPPS_PROVIDER_REMINDER_BEFORE_EXPIRY = 'IDENTITY_PROVIDERS.LUMAPPS_PROVIDER_REMINDER_BEFORE_EXPIRY',
    /**
     * @value Must be less than the password expiration period.
     * @description Validation error when the reminder period is not shorter than the password expiration period.
     */
    LUMAPPS_PROVIDER_REMINDER_ERROR = 'IDENTITY_PROVIDERS.LUMAPPS_PROVIDER_REMINDER_ERROR',
    /**
     * @value Required while 2-step verification is enabled.
     * @description Tooltip on the locked password login switch and the read-only visibility field.
     */
    LUMAPPS_PROVIDER_REQUIRED_BY_TWO_STEP_VERIFICATION = 'IDENTITY_PROVIDERS.LUMAPPS_PROVIDER_REQUIRED_BY_TWO_STEP_VERIFICATION',
    /**
     * @value Lowercase letters (a–z)
     * @description Password complexity checkbox: passwords must contain a lowercase letter.
     */
    LUMAPPS_PROVIDER_REQUIRE_LOWERCASE = 'IDENTITY_PROVIDERS.LUMAPPS_PROVIDER_REQUIRE_LOWERCASE',
    /**
     * @value Numbers (0–9)
     * @description Password complexity checkbox: passwords must contain a digit.
     */
    LUMAPPS_PROVIDER_REQUIRE_NUMBER = 'IDENTITY_PROVIDERS.LUMAPPS_PROVIDER_REQUIRE_NUMBER',
    /**
     * @value Special characters (such as @, #, $, %)
     * @description Password complexity checkbox: passwords must contain a special character.
     */
    LUMAPPS_PROVIDER_REQUIRE_SPECIAL_CHARACTER = 'IDENTITY_PROVIDERS.LUMAPPS_PROVIDER_REQUIRE_SPECIAL_CHARACTER',
    /**
     * @value Uppercase letters (A–Z)
     * @description Password complexity checkbox: passwords must contain an uppercase letter.
     */
    LUMAPPS_PROVIDER_REQUIRE_UPPERCASE = 'IDENTITY_PROVIDERS.LUMAPPS_PROVIDER_REQUIRE_UPPERCASE',
    /**
     * @value Turning it off before saving puts them back as they were.
     * @description Confirmation dialog text: turning 2-step verification off before saving restores the changed options.
     */
    LUMAPPS_PROVIDER_TURN_OFF_RESTORES = 'IDENTITY_PROVIDERS.LUMAPPS_PROVIDER_TURN_OFF_RESTORES',
    /**
     * @value Turning it off before saving puts it back as it was.
     * @description Confirmation dialog text: turning 2-step verification off before saving restores the changed option (one option).
     */
    LUMAPPS_PROVIDER_TURN_OFF_RESTORES_ONE = 'IDENTITY_PROVIDERS.LUMAPPS_PROVIDER_TURN_OFF_RESTORES_ONE',
    /**
     * @value Turn on
     * @description Confirm button of the dialog shown before turning 2-step verification on.
     */
    LUMAPPS_PROVIDER_TURN_ON = 'IDENTITY_PROVIDERS.LUMAPPS_PROVIDER_TURN_ON',
    /**
     * @value This also changes this option:
     * @description Confirmation dialog text introducing the option that turning 2-step verification on changes (one option, when magic link login is not available).
     */
    LUMAPPS_PROVIDER_TURN_ON_EFFECT = 'IDENTITY_PROVIDERS.LUMAPPS_PROVIDER_TURN_ON_EFFECT',
    /**
     * @value This also changes these options:
     * @description Confirmation dialog text introducing the options that turning 2-step verification on changes (several options).
     */
    LUMAPPS_PROVIDER_TURN_ON_EFFECTS = 'IDENTITY_PROVIDERS.LUMAPPS_PROVIDER_TURN_ON_EFFECTS',
    /**
     * @value Turn on 2-step verification?
     * @description Title of the confirmation dialog shown before turning 2-step verification on.
     */
    LUMAPPS_PROVIDER_TURN_ON_TWO_STEP_VERIFICATION = 'IDENTITY_PROVIDERS.LUMAPPS_PROVIDER_TURN_ON_TWO_STEP_VERIFICATION',
    /**
     * @value Require users to confirm their identity a second time when they sign in: after entering their password, they open a link sent to their email.
     * @description Description of the 2-step verification section of the LumApps Provider settings page.
     */
    LUMAPPS_PROVIDER_TWO_STEP_VERIFICATION_DESCRIPTION = 'IDENTITY_PROVIDERS.LUMAPPS_PROVIDER_TWO_STEP_VERIFICATION_DESCRIPTION',
    /**
     * @value While 2-step verification is on, password login is on, with its login button visible on Web & Mobile application, and magic link login is off. Users without an email address can't sign in. Users already signed in stay signed in: 2-step verification applies from their next sign-in.
     * @description Warning under the 2-step verification switch while it is on, when magic link login is available to the organization.
     */
    LUMAPPS_PROVIDER_TWO_STEP_VERIFICATION_WARNING = 'IDENTITY_PROVIDERS.LUMAPPS_PROVIDER_TWO_STEP_VERIFICATION_WARNING',
    /**
     * @value While 2-step verification is on, password login is on, with its login button visible on Web & Mobile application. Users without an email address can't sign in. Users already signed in stay signed in: 2-step verification applies from their next sign-in.
     * @description Warning under the 2-step verification switch while it is on, when magic link login is not available to the organization.
     */
    LUMAPPS_PROVIDER_TWO_STEP_VERIFICATION_WARNING_NO_MAGIC_LINK = 'IDENTITY_PROVIDERS.LUMAPPS_PROVIDER_TWO_STEP_VERIFICATION_WARNING_NO_MAGIC_LINK',
    /**
     * @value Unavailable while 2-step verification is enabled.
     * @description Tooltip on the locked magic link login switch.
     */
    LUMAPPS_PROVIDER_UNAVAILABLE_WITH_TWO_STEP_VERIFICATION = 'IDENTITY_PROVIDERS.LUMAPPS_PROVIDER_UNAVAILABLE_WITH_TWO_STEP_VERIFICATION',
    /**
     * @value Using metadata descriptor XML
     */
    METADATA_HELPER = 'ADMIN.RESELLER_CONSOLE_CUSTOMER.METADATA_HELPER',
    /**
     * @value This option requires Office 365 login authorizations. Please <a href="https://azure-enterprise-application.lumapps.net/" target="_blank" class="tc-primary">grant access to LumApps</a>.
     */
    MICROSOFT_HELPER = 'ADMIN.PROVIDER.MICROSOFT.HELPER',
    /**
     * @value Client ID SDK for mobile authentication
     */
    MOBILE_OKTA_CLIENT_ID_SDK = 'RESELLER_CONSOLE.MOBILE_OKTA_CLIENT_ID_SDK',
    /**
     * @value Public identifier for the client that is required for all OAuth mobile flows. This feature improves security and supports more use cases like passkeys sign-in. If empty, the web client id will be used.
     */
    MOBILE_OKTA_CLIENT_ID_SDK_HELPER = 'RESELLER_CONSOLE.MOBILE_OKTA_CLIENT_ID_SDK_HELPER',
    /**
     * @value Mobile client credentials (only to configure the SDK for mobile native integration)
     */
    MOBILE_OKTA_CRED_SDK = 'RESELLER_CONSOLE.MOBILE_OKTA_CRED_SDK',
    /**
     * @value Choose which SAML attribute is matched to a user during login
     * @description Helper text for the SAML name ID type selector
     */
    NAME_ID_TYPE_HELPER = 'ADMIN.IDENTITY_PROVIDERS.NAME_ID_TYPE_HELPER',
    /**
     * @value Name ID type
     * @description Label for the SAML name ID type selector
     */
    NAME_ID_TYPE_LABEL = 'ADMIN.IDENTITY_PROVIDERS.NAME_ID_TYPE_LABEL',
    /**
     * @value Provider user ID
     * @description SAML name ID type option: match users by their provider user ID
     */
    NAME_ID_TYPE_OPTION_PROVIDER_USER_ID = 'ADMIN.IDENTITY_PROVIDERS.NAME_ID_TYPE_OPTION_PROVIDER_USER_ID',
    /**
     * @value Automatic
     * @description SAML name ID type option: automatically deduced
     */
    NAME_ID_TYPE_OPTION_UNSET = 'ADMIN.IDENTITY_PROVIDERS.NAME_ID_TYPE_OPTION_UNSET',
    /**
     * @value A new certificate for the year to come is available.
     */
    NEW_CERTIFICATE_VERSION_INFO = 'ADMIN.IDENTITY_PROVIDERS.NEW_CERTIFICATE_VERSION_INFO',
    /**
     * @value New provider
     */
    NEW_PROVIDER = 'ADMIN.PROVIDER.NEW_PROVIDER',
    /**
     * @value Options
     */
    OPTIONS = 'ADMIN.PROVIDER.OPTIONS',
    /**
     * @value Force login for all users through the redirection, using their source credentials
     */
    PROVIDER_AUTO_LOGIN_REDIRECT_HELPER = 'ADMIN.PROVIDER.AUTO_LOGIN_REDIRECT_HELPER',
    /**
     * @value Enable login redirection
     */
    PROVIDER_LOGIN_REDIRECT = 'ADMIN.PROVIDER.LOGIN_REDIRECT',
    /**
     * @value Redirect to the personalized login process
     */
    PROVIDER_LOGIN_REDIRECT_HELPER = 'ADMIN.PROVIDER.LOGIN_REDIRECT_HELPER',
    /**
     * @value Choose where the login button is visible
     */
    PROVIDER_LOGIN_VISIBILITY_HELPER = 'ADMIN.PROVIDER.LOGIN_VISIBILITY_HELPER',
    /**
     * @value Visibility of the login button
     */
    PROVIDER_LOGIN_VISIBILITY_LABEL = 'ADMIN.PROVIDER.LOGIN_VISIBILITY_LABEL',
    /**
     * @value Mobile application
     */
    PROVIDER_LOGIN_VISIBILITY_MOBILE = 'ADMIN.PROVIDER.LOGIN_VISIBILITY_MOBILE',
    /**
     * @value Web
     */
    PROVIDER_LOGIN_VISIBILITY_WEB = 'ADMIN.PROVIDER.LOGIN_VISIBILITY_WEB',
    /**
     * @value Web & Mobile application
     */
    PROVIDER_LOGIN_VISIBILITY_WEBANDMOBILE = 'ADMIN.PROVIDER.LOGIN_VISIBILITY_WEBANDMOBILE',
    /**
     * @value Provider management
     */
    PROVIDER_MANAGEMENT = 'ADMIN.PROVIDER.PROVIDER_MANAGEMENT',
    /**
     * @value Select a value
     */
    PROVIDER_SELECT_VALUE = 'GLOBAL.INPUT.SELECT_VALUE',
    /**
     * @value Provider reference
     */
    PROVIDER_URL_REFERENCE = 'ADMIN.RESELLER_CONSOLE_CUSTOMER.PROVIDER_URL_REFERENCE',
    /**
     * @value Enable user provisioning
     */
    PROVISIONING_ENABLED = 'ADMIN.PROVIDER.PROVISIONING_ENABLED',
    /**
     * @value This provider will be used during the user synchronization
     */
    PROVISIONING_ENABLED_HELPER = 'ADMIN.PROVIDER.PROVISIONING_ENABLED_HELPER',
    /**
     * @value Okta access has failed, review information for "Source" and "Client credentials" sections.
     */
    PROVISIONING_SOURCE_ERROR = 'ADMIN.PROVIDER.PROVISIONING_SOURCE_ERROR',
    /**
     * @value Provisioning endpoint
     * @description Label used to show an URL linked to provisioning.
     */
    PROVISIONING_URL = 'ADMIN.PROVIDER.PROVISIONING_URL',
    /**
     * @value The provisioning endpoint is shown for information purpose only.
     */
    PROVISIONING_URL_INFO = 'ADMIN.PROVIDER.PROVISIONING_URL_INFO',
    /**
     * @value No endpoint to display. <br> there is no automatic daily provisioning set up for this provider
     */
    PROVISIONING_URL_MISSING = 'ADMIN.PROVIDER.PROVISIONING_URL_MISSING',
    /**
     * @value Federation has stopped for
     * @description Status message displayed to show if setup has errors or not.
     * Message is split in 3 KEYS : This one + number of errors + end of the message.
     */
    PROV_FEDERATION_ERROR_BEGIN = 'PROV_FEDERATION.ERROR_BEGIN',
    /**
     * @value because of errors.
     * @description Status message displayed to show if setup has errors or not.
     * Message is split in 3 KEYS : begin of the message + number of errors + end of the message.
     */
    PROV_FEDERATION_ERROR_END = 'PROV_FEDERATION.ERROR_END',
    /**
     * @value Users federation successful
     * @description Status message displayed to show if setup has errors or not
     */
    PROV_FEDERATION_SUCCESS = 'PROV_FEDERATION.SUCCESS',
    /**
     * @value The identity provider quota of this customer has been reached.
     */
    QUOTA_EXCEED = 'ADMIN.PROVIDER.QUOTA.EXCEED',
    /**
     * @value Redirect to Login Provider
     */
    REDIRECT_ENABLED = 'ADMIN.PROVIDER.REDIRECT_ENABLED',
    /**
     * @value Authorize LumApps to redirect after SAML login to the login provider portal to get the integration token.
     */
    REDIRECT_HELPER = 'ADMIN.PROVIDER.REDIRECT_HELPER',
    /**
     * @value Required while 2FA is enabled
     * @description Tooltip on the password login switch, explaining why it is locked on while two-factor authentication is enabled.
     */
    REQUIRED_WHILE_TWO_STEP_VERIFICATION_ENABLED = 'ADMIN.PROVIDER.REQUIRED_WHILE_TWO_STEP_VERIFICATION_ENABLED',
    /**
     * @value Require 2-step verification
     * @description Label of the switch enabling two-factor authentication on the LumApps (email) identity provider.
     */
    REQUIRE_TWO_STEP_VERIFICATION = 'ADMIN.PROVIDER.REQUIRE_TWO_STEP_VERIFICATION',
    /**
     * @value Users must confirm their identity with a link sent by email after signing in with their password. Magic link login is turned off while 2-step verification is enabled.
     * @description Helper text under the two-factor authentication switch, explaining that magic link login is disabled while it is on.
     */
    REQUIRE_TWO_STEP_VERIFICATION_HELPER = 'ADMIN.PROVIDER.REQUIRE_TWO_STEP_VERIFICATION_HELPER',
    /**
     * @value Can't determine which provider's domain you wanted to use.
     */
    SAVE_DOMAIN_ERROR = 'ADMIN.PROVIDER.SAVE.DOMAIN_ERROR',
    /**
     * @value An error occurred when saving the provider.
     */
    SAVE_ERROR = 'ADMIN.PROVIDER.SAVE.ERROR',
    /**
     * @value The provider has been saved successfully.
     */
    SAVE_SUCCESS = 'ADMIN.PROVIDER.SAVE.SUCCESS',
    /**
     * @value LumApps identity provider
     */
    SCIM_PROVIDER_TYPE = 'ADMIN.PROVIDER.SCIM_PROVIDER_TYPE',
    /**
     * @value Bind users and groups to the LumApps identity provider
     */
    SCIM_PROVIDER_TYPE_PLACEHOLDER = 'ADMIN.PROVIDER.SCIM_PROVIDER_TYPE_PLACEHOLDER',
    /**
     * @value See our documentation.
     */
    SEE_OUR_DOC = 'ADMIN.GLOBAL.SEE_OUR_DOC',
    /**
     * @value An error occurred when deleting the user space.
     */
    SERVICE_DELETE_USERSPACE_ERROR = 'ADMIN.PROVIDER.SERVICE.DELETE_USERSPACE_ERROR',
    /**
     * @value The user space has been deleted successfully.
     */
    SERVICE_DELETE_USERSPACE_SUCCESS = 'ADMIN.PROVIDER.SERVICE.DELETE_USERSPACE_SUCCESS',
    /**
     * @value Error while retrieving provider list
     */
    SERVICE_FETCH_PROVIDER_ERROR = 'ADMIN.PROVIDER.SERVICE.FETCH_PROVIDER_ERROR',
    /**
     * @value Error while retrieving user space information
     */
    SERVICE_FETCH_USERSPACE_DETAIL_ERROR = 'ADMIN.PROVIDER.SERVICE.FETCH_USERSPACE_DETAIL_ERROR',
    /**
     * @value Error while retrieving user space list
     */
    SERVICE_FETCH_USERSPACE_ERROR = 'ADMIN.PROVIDER.SERVICE.FETCH_USERSPACE_ERROR',
    /**
     * @value An error occurred when saving the user space.
     */
    SERVICE_SAVE_USERSPACE_ERROR = 'ADMIN.PROVIDER.SERVICE.SAVE_USERSPACE_ERROR',
    /**
     * @value The user space has been saved successfully.
     */
    SERVICE_SAVE_USERSPACE_SUCCESS = 'ADMIN.PROVIDER.SERVICE.SAVE_USERSPACE_SUCCESS',
    /**
     * @value Signing certificate version
     */
    SIGNING_CERTIFICATE_VERSION = 'ADMIN.IDENTITY_PROVIDERS.SIGNING_CERTIFICATE_VERSION',
    /**
     * @value One month before the current certificate expires, a new certificate will appear here. You can switch to it at any time before the expiration date.
     */
    SIGNING_CERTIFICATE_VERSION_DESCRIPTION = 'ADMIN.IDENTITY_PROVIDERS.SIGNING_CERTIFICATE_VERSION_DESCRIPTION',
    /**
     * @value Source
     */
    SOURCE = 'ADMIN.PROVIDER.SOURCE',
    /**
     * @value Enable Single Sign-On
     */
    SSO_ENABLED = 'ADMIN.PROVIDER.SSO_ENABLED',
    /**
     * @value Manage authentication of all Google apps with LumApps
     */
    SSO_ENABLED_HELPER = 'ADMIN.PROVIDER.SSO_ENABLED_HELPER',
    /**
     * @value Synchronize only users included in the Okta application linked to LumApps
     */
    SYNC_APPLICATION_ONLY = 'ADMIN.PROVIDER.SYNC_APPLICATION_ONLY',
    /**
     * @value Restrict the provisioning to users included in the Okta application linked to LumApps
     */
    SYNC_APPLICATION_ONLY_HELPER = 'ADMIN.PROVIDER.SYNC_APPLICATION_ONLY_HELPER',
    /**
     * @value When you enable this option, you must ensure that the User profile mapping with Okta is correct.
     */
    SYNC_APPLICATION_ONLY_WARNING = 'ADMIN.PROVIDER.SYNC_APPLICATION_ONLY_WARNING',
    /**
     * @value Synchronization from LumApps to G Suite
     */
    SYNC_TO_GSUITE = 'ADMIN.PROVIDER.SYNC_TO_GSUITE',
    /**
     * @value Action
     */
    TABLE_HEADER_ACTION = 'ADMIN.PROVIDER.TABLE_HEADER_ACTION',
    /**
     * @value Last synchronization
     */
    TABLE_HEADER_LAST_SYNC = 'ADMIN.PROVIDER.TABLE_HEADER_LAST_SYNC',
    /**
     * @value Provider
     */
    TABLE_HEADER_PROVIDER = 'ADMIN.PROVIDER.TABLE_HEADER_PROVIDER',
    /**
     * @value Technical account used for synchronization.
     */
    TECHNICAL_ACCOUNT = 'ADMIN.PROVIDER.TECHNICAL_ACCOUNT',
    /**
     * @value To create a technical account, refer to the <a href="https://docs.lumapps.com/docs/install-l0027254914098205907google-install#l43815895359036405" target="_blank" class="tc-primary">documentation</a>.
     */
    TECHNICAL_ACCOUNT_HELPER = 'ADMIN.PROVIDER.TECHNICAL_ACCOUNT.HELPER',
    /**
     * @value Unavailable while 2FA is enabled
     * @description Tooltip on the magic link login switch, explaining why it is locked off while two-factor authentication is enabled.
     */
    UNAVAILABLE_WHILE_TWO_STEP_VERIFICATION_ENABLED = 'ADMIN.PROVIDER.UNAVAILABLE_WHILE_TWO_STEP_VERIFICATION_ENABLED',
    /**
     * @value Upload a logo
     */
    UPLOAD_LOGO = 'ADMIN.RESELLER_CONSOLE_CUSTOMER.UPLOAD_LOGO',
    /**
     * @value Import metadata file generated by your identity provider
     */
    UPLOAD_METADATA = 'ADMIN.RESELLER_CONSOLE_CUSTOMER.UPLOAD_METADATA',
    /**
     * @value Show applications in the launcher
     */
    USE_BOOKMARKS = 'ADMIN.PROVIDER.USE_BOOKMARKS',
    /**
     * @value Add the provider apps in the top bar launcher
     */
    USE_BOOKMARKS_HELPER = 'ADMIN.PROVIDER.USE_BOOKMARKS_HELPER',
    /**
     * @value Tenant ID/Domain will be available after saving
     */
    VALIDATION_AFTER_SAVING = 'ADMIN.PROVIDER.DOMAIN.VALIDATION_AFTER_SAVING',
    /**
     * @value Sign in with your account to add the tenant ID / domain
     */
    VERIF_AFTER_LOGIN = 'ADMIN.PROVIDER.DOMAIN.VERIF_AFTER_LOGIN',
}
